export const readClipboard = async () => {
    return navigator.clipboard.readText();
};
